import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AccountingInfoSelectWrapper = styled.div`
  display: grid;
  align-items: center;
  gap: ${Spacing.S8};
  grid-template-columns: 1fr 1fr;
`
